import Ne from "react";
import pn from "@material-ui/icons/DateRange";
import De from "@material-ui/core/styles/makeStyles";
import gn from "mirador/dist/es/src/containers/CompanionWindow";
import { useTranslation as z } from "react-i18next";
import K from "@material-ui/core/Box";
import U from "@material-ui/core/Link";
import D from "@material-ui/core/Typography";
import ee from "mirador/dist/es/src/containers/CollapsibleSection";
import mn from "@material-ui/core/AccordionDetails";
import hn from "@material-ui/core/List";
import En from "@material-ui/core/ListItem";
import yn from "@material-ui/core/ListItemText";
import _n from "@material-ui/core/ListSubheader";
import xn from "@material-ui/icons/ExpandMore";
import Sn from "@material-ui/core/Accordion";
import Pe from "@material-ui/core/styles/withStyles";
import Tn from "@material-ui/core/AccordionSummary";
import Rn from "mirador/dist/es/src/state/actions/action-types";
import { getWindowConfig as wn } from "mirador/dist/es/src/state/selectors";
import { miradorSlice as ne } from "mirador/dist/es/src/state/selectors/utils";
var ge = { exports: {} }, V = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ie;
function On() {
  if (Ie) return V;
  Ie = 1;
  var n = Ne, e = 60103;
  if (V.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var t = Symbol.for;
    e = t("react.element"), V.Fragment = t("react.fragment");
  }
  var a = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, c, m) {
    var v, _ = {}, S = null, w = null;
    m !== void 0 && (S = "" + m), c.key !== void 0 && (S = "" + c.key), c.ref !== void 0 && (w = c.ref);
    for (v in c) i.call(c, v) && !f.hasOwnProperty(v) && (_[v] = c[v]);
    if (d && d.defaultProps) for (v in c = d.defaultProps, c) _[v] === void 0 && (_[v] = c[v]);
    return { $$typeof: e, type: d, key: S, ref: w, props: _, _owner: a.current };
  }
  return V.jsx = l, V.jsxs = l, V;
}
var le = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var be;
function In() {
  return be || (be = 1, function(n) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Ne, t = 60103, a = 60106;
      n.Fragment = 60107;
      var i = 60108, f = 60114, l = 60109, d = 60110, c = 60112, m = 60113, v = 60120, _ = 60115, S = 60116, w = 60121, O = 60122, j = 60117, N = 60129, P = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var E = Symbol.for;
        t = E("react.element"), a = E("react.portal"), n.Fragment = E("react.fragment"), i = E("react.strict_mode"), f = E("react.profiler"), l = E("react.provider"), d = E("react.context"), c = E("react.forward_ref"), m = E("react.suspense"), v = E("react.suspense_list"), _ = E("react.memo"), S = E("react.lazy"), w = E("react.block"), O = E("react.server.block"), j = E("react.fundamental"), E("react.scope"), E("react.opaque.id"), N = E("react.debug_trace_mode"), E("react.offscreen"), P = E("react.legacy_hidden");
      }
      var k = typeof Symbol == "function" && Symbol.iterator, L = "@@iterator";
      function Q(r) {
        if (r === null || typeof r != "object")
          return null;
        var o = k && r[k] || r[L];
        return typeof o == "function" ? o : null;
      }
      var Y = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function T(r) {
        {
          for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), p = 1; p < o; p++)
            s[p - 1] = arguments[p];
          qe("error", r, s);
        }
      }
      function qe(r, o, s) {
        {
          var p = Y.ReactDebugCurrentFrame, x = "";
          if (F) {
            var y = A(F.type), h = F._owner;
            x += Be(y, F._source, h && A(h.type));
          }
          x += p.getStackAddendum(), x !== "" && (o += "%s", s = s.concat([x]));
          var g = s.map(function(I) {
            return "" + I;
          });
          g.unshift("Warning: " + o), Function.prototype.apply.call(console[r], console, g);
        }
      }
      var He = !1;
      function Ve(r) {
        return !!(typeof r == "string" || typeof r == "function" || r === n.Fragment || r === f || r === N || r === i || r === m || r === v || r === P || He || typeof r == "object" && r !== null && (r.$$typeof === S || r.$$typeof === _ || r.$$typeof === l || r.$$typeof === d || r.$$typeof === c || r.$$typeof === j || r.$$typeof === w || r[0] === O));
      }
      var ae = /^(.*)[\\\/]/;
      function Be(r, o, s) {
        var p = "";
        if (o) {
          var x = o.fileName, y = x.replace(ae, "");
          if (/^index\./.test(y)) {
            var h = x.match(ae);
            if (h) {
              var g = h[1];
              if (g) {
                var I = g.replace(ae, "");
                y = I + "/" + y;
              }
            }
          }
          p = " (at " + y + ":" + o.lineNumber + ")";
        } else s && (p = " (created by " + s + ")");
        return `
    in ` + (r || "Unknown") + p;
      }
      var Ke = 1;
      function ze(r) {
        return r._status === Ke ? r._result : null;
      }
      function Ge(r, o, s) {
        var p = o.displayName || o.name || "";
        return r.displayName || (p !== "" ? s + "(" + p + ")" : s);
      }
      function A(r) {
        if (r == null)
          return null;
        if (typeof r.tag == "number" && T("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof r == "function")
          return r.displayName || r.name || null;
        if (typeof r == "string")
          return r;
        switch (r) {
          case n.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case f:
            return "Profiler";
          case i:
            return "StrictMode";
          case m:
            return "Suspense";
          case v:
            return "SuspenseList";
        }
        if (typeof r == "object")
          switch (r.$$typeof) {
            case d:
              return "Context.Consumer";
            case l:
              return "Context.Provider";
            case c:
              return Ge(r, r.render, "ForwardRef");
            case _:
              return A(r.type);
            case w:
              return A(r.render);
            case S: {
              var o = r, s = ze(o);
              if (s)
                return A(s);
              break;
            }
          }
        return null;
      }
      var ye = {};
      Y.ReactDebugCurrentFrame;
      var F = null;
      function Z(r) {
        F = r;
      }
      function Je(r, o, s, p, x) {
        {
          var y = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var h in r)
            if (y(r, h)) {
              var g = void 0;
              try {
                if (typeof r[h] != "function") {
                  var I = Error((p || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw I.name = "Invariant Violation", I;
                }
                g = r[h](o, h, p, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (W) {
                g = W;
              }
              g && !(g instanceof Error) && (Z(x), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", s, h, typeof g), Z(null)), g instanceof Error && !(g.message in ye) && (ye[g.message] = !0, Z(x), T("Failed %s type: %s", s, g.message), Z(null));
            }
        }
      }
      var G = Y.ReactCurrentOwner, ie = Object.prototype.hasOwnProperty, Qe = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, _e, xe, oe;
      oe = {};
      function Ze(r) {
        if (ie.call(r, "ref")) {
          var o = Object.getOwnPropertyDescriptor(r, "ref").get;
          if (o && o.isReactWarning)
            return !1;
        }
        return r.ref !== void 0;
      }
      function Xe(r) {
        if (ie.call(r, "key")) {
          var o = Object.getOwnPropertyDescriptor(r, "key").get;
          if (o && o.isReactWarning)
            return !1;
        }
        return r.key !== void 0;
      }
      function en(r, o) {
        if (typeof r.ref == "string" && G.current && o && G.current.stateNode !== o) {
          var s = A(G.current.type);
          oe[s] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(G.current.type), r.ref), oe[s] = !0);
        }
      }
      function nn(r, o) {
        {
          var s = function() {
            _e || (_e = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
          };
          s.isReactWarning = !0, Object.defineProperty(r, "key", {
            get: s,
            configurable: !0
          });
        }
      }
      function rn(r, o) {
        {
          var s = function() {
            xe || (xe = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
          };
          s.isReactWarning = !0, Object.defineProperty(r, "ref", {
            get: s,
            configurable: !0
          });
        }
      }
      var tn = function(r, o, s, p, x, y, h) {
        var g = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: t,
          // Built-in properties that belong on the element
          type: r,
          key: o,
          ref: s,
          props: h,
          // Record the component responsible for creating this element.
          _owner: y
        };
        return g._store = {}, Object.defineProperty(g._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(g, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: p
        }), Object.defineProperty(g, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: x
        }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
      };
      function an(r, o, s, p, x) {
        {
          var y, h = {}, g = null, I = null;
          s !== void 0 && (g = "" + s), Xe(o) && (g = "" + o.key), Ze(o) && (I = o.ref, en(o, x));
          for (y in o)
            ie.call(o, y) && !Qe.hasOwnProperty(y) && (h[y] = o[y]);
          if (r && r.defaultProps) {
            var W = r.defaultProps;
            for (y in W)
              h[y] === void 0 && (h[y] = W[y]);
          }
          if (g || I) {
            var $ = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
            g && nn(h, $), I && rn(h, $);
          }
          return tn(r, g, I, x, p, G.current, h);
        }
      }
      var se = Y.ReactCurrentOwner;
      Y.ReactDebugCurrentFrame;
      function q(r) {
        F = r;
      }
      var ue;
      ue = !1;
      function ce(r) {
        return typeof r == "object" && r !== null && r.$$typeof === t;
      }
      function Se() {
        {
          if (se.current) {
            var r = A(se.current.type);
            if (r)
              return `

Check the render method of \`` + r + "`.";
          }
          return "";
        }
      }
      function on(r) {
        return "";
      }
      var Te = {};
      function sn(r) {
        {
          var o = Se();
          if (!o) {
            var s = typeof r == "string" ? r : r.displayName || r.name;
            s && (o = `

Check the top-level render call using <` + s + ">.");
          }
          return o;
        }
      }
      function Re(r, o) {
        {
          if (!r._store || r._store.validated || r.key != null)
            return;
          r._store.validated = !0;
          var s = sn(o);
          if (Te[s])
            return;
          Te[s] = !0;
          var p = "";
          r && r._owner && r._owner !== se.current && (p = " It was passed a child from " + A(r._owner.type) + "."), q(r), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, p), q(null);
        }
      }
      function we(r, o) {
        {
          if (typeof r != "object")
            return;
          if (Array.isArray(r))
            for (var s = 0; s < r.length; s++) {
              var p = r[s];
              ce(p) && Re(p, o);
            }
          else if (ce(r))
            r._store && (r._store.validated = !0);
          else if (r) {
            var x = Q(r);
            if (typeof x == "function" && x !== r.entries)
              for (var y = x.call(r), h; !(h = y.next()).done; )
                ce(h.value) && Re(h.value, o);
          }
        }
      }
      function un(r) {
        {
          var o = r.type;
          if (o == null || typeof o == "string")
            return;
          var s;
          if (typeof o == "function")
            s = o.propTypes;
          else if (typeof o == "object" && (o.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          o.$$typeof === _))
            s = o.propTypes;
          else
            return;
          if (s) {
            var p = A(o);
            Je(s, r.props, "prop", p, r);
          } else if (o.PropTypes !== void 0 && !ue) {
            ue = !0;
            var x = A(o);
            T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
          }
          typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function cn(r) {
        {
          for (var o = Object.keys(r.props), s = 0; s < o.length; s++) {
            var p = o[s];
            if (p !== "children" && p !== "key") {
              q(r), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", p), q(null);
              break;
            }
          }
          r.ref !== null && (q(r), T("Invalid attribute `ref` supplied to `React.Fragment`."), q(null));
        }
      }
      function Oe(r, o, s, p, x, y) {
        {
          var h = Ve(r);
          if (!h) {
            var g = "";
            (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (g += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var I = on();
            I ? g += I : g += Se();
            var W;
            r === null ? W = "null" : Array.isArray(r) ? W = "array" : r !== void 0 && r.$$typeof === t ? (W = "<" + (A(r.type) || "Unknown") + " />", g = " Did you accidentally export a JSX literal instead of a component?") : W = typeof r, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, g);
          }
          var $ = an(r, o, s, x, y);
          if ($ == null)
            return $;
          if (h) {
            var H = o.children;
            if (H !== void 0)
              if (p)
                if (Array.isArray(H)) {
                  for (var fe = 0; fe < H.length; fe++)
                    we(H[fe], r);
                  Object.freeze && Object.freeze(H);
                } else
                  T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                we(H, r);
          }
          return r === n.Fragment ? cn($) : un($), $;
        }
      }
      function fn(r, o, s) {
        return Oe(r, o, s, !0);
      }
      function ln(r, o, s) {
        return Oe(r, o, s, !1);
      }
      var dn = ln, vn = fn;
      n.jsx = dn, n.jsxs = vn;
    }();
  }(le)), le;
}
process.env.NODE_ENV === "production" ? ge.exports = On() : ge.exports = In();
var u = ge.exports;
const ke = () => /* @__PURE__ */ u.jsx(pn, {});
ke.value = "calendar";
const bn = ({
  className: n,
  lastSearchUrl: e
}) => {
  const { t } = z();
  return e ? /* @__PURE__ */ u.jsx(K, { className: n, children: /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: e, underline: "hover", children: t("backToSearch") }) }) }) : null;
}, jn = ({
  className: n,
  day: e,
  month: t,
  multId: a,
  year: i
}) => {
  const { i18n: f, t: l } = z();
  return [e, t, a, i].every((d) => !d) ? null : /* @__PURE__ */ u.jsx(K, { className: n, children: /* @__PURE__ */ u.jsxs(ee, { id: "calendar", label: l("calendar"), children: [
    i && /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/calendar/${i}`, underline: "hover", children: l("newspapersFromYear", { year: i }) }) }),
    i && t && e && /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/calendar/${i}/${t}/${e}`, underline: "hover", children: l("newspapersFromDate", {
      date: new Date(i, t - 1, e).toLocaleDateString(
        f.language,
        {
          day: "numeric",
          month: "long",
          year: "numeric"
        }
      )
    }) }) }),
    a && /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/calendar/newspaper/${a}`, underline: "hover", children: l("calendarCurrentNewspaper") }) })
  ] }) });
}, An = ({
  className: n,
  neighbors: { left: e, right: t }
}) => {
  const { t: a } = z();
  return [e, t].every((i) => !i) ? null : /* @__PURE__ */ u.jsx(K, { className: n, children: /* @__PURE__ */ u.jsxs(ee, { id: "quick-navigation", label: a("quickNavigation"), children: [
    e && /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/view/${e.id}`, underline: "hover", children: a("previousIssue") }) }),
    t && /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/view/${t.id}`, underline: "hover", children: a("nextIssue") }) })
  ] }) });
}, Cn = ({ className: n, issues: e }) => {
  const { t } = z();
  return /* @__PURE__ */ u.jsx(K, { className: n, children: /* @__PURE__ */ u.jsx(ee, { id: "undated-issues", label: t("undatedIssues"), children: e.length === 0 ? /* @__PURE__ */ u.jsx(D, { variant: "body2", children: t("noUndatedIssues") }) : e.map(({ identifier: { id: a }, text: i }) => /* @__PURE__ */ u.jsx(D, { variant: "body2", children: /* @__PURE__ */ u.jsx(U, { href: `/view/${a}`, underline: "hover", children: i }) }, a)) }) });
}, Nn = Pe({
  root: {
    "&$expanded": {
      margin: "auto",
      "&:before": {
        opacity: 1
      }
    }
  },
  expanded: {}
})(Sn), Dn = Pe({
  root: {
    padding: 0,
    "&$expanded": {
      minHeight: 48
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(Tn), Pn = De((n) => ({
  dayListHeader: {
    display: "flex"
  },
  dayListHeaderContent: {
    marginRight: n.spacing(0.5),
    width: n.spacing(2.5)
  },
  issueListItem: {
    paddingBottom: 0,
    paddingLeft: n.spacing(3),
    paddingTop: 0
  },
  monthDetails: {
    flexDirection: "column",
    padding: 0
  }
})), kn = ({
  className: n,
  daysWithIssues: e = [],
  monthsWithIssues: t,
  multId: a,
  openMonth: i,
  requestDaysWithIssue: f,
  resetOpenMonth: l,
  year: d
}) => {
  const { dayListHeader: c, dayListHeaderContent: m, issueListItem: v, monthDetails: _ } = Pn(), { i18n: S, t: w } = z(), O = (j) => (N, P) => P ? f({ month: j, multId: a, year: d }) : l();
  return t.length === 0 || !d ? null : /* @__PURE__ */ u.jsx(K, { className: n, children: /* @__PURE__ */ u.jsx(
    ee,
    {
      id: "year-overview",
      label: w("yearOverview", { year: d }),
      children: /* @__PURE__ */ u.jsx(K, { children: t.map(({ label: j, value: N }) => /* @__PURE__ */ u.jsxs(
        Nn,
        {
          elevation: 0,
          expanded: !!i && `panel-${i}` == `panel-${N}`,
          onChange: O(N),
          children: [
            /* @__PURE__ */ u.jsx(Dn, { expandIcon: /* @__PURE__ */ u.jsx(xn, {}), children: /* @__PURE__ */ u.jsx(D, { variant: "body2", children: j }) }),
            /* @__PURE__ */ u.jsx(mn, { className: _, children: e.map(({ records: P, value: E }) => /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsx(
              hn,
              {
                dense: !0,
                disablePadding: !0,
                subheader: /* @__PURE__ */ u.jsxs(_n, { className: c, disableGutters: !0, children: [
                  /* @__PURE__ */ u.jsx(
                    D,
                    {
                      className: m,
                      color: "textPrimary",
                      component: "span",
                      variant: "body2",
                      children: E
                    }
                  ),
                  /* @__PURE__ */ u.jsx(
                    D,
                    {
                      color: "textSecondary",
                      component: "span",
                      variant: "body2",
                      children: new Date(d, N - 1, E).toLocaleDateString(
                        S.language,
                        {
                          weekday: "short"
                        }
                      )
                    }
                  )
                ] }),
                children: P.sort(
                  (k, L) => k.sortIndex.localeCompare(
                    L.sortIndex,
                    S.language,
                    { numeric: !0 }
                  )
                ).map(({ identifier: { id: k }, text: L }) => /* @__PURE__ */ u.jsx(
                  En,
                  {
                    className: v,
                    component: U,
                    dense: !0,
                    disableGutters: !0,
                    href: `/view/${k}`,
                    underline: "hover",
                    children: /* @__PURE__ */ u.jsx(yn, { primary: L })
                  },
                  k
                ))
              },
              `month-${N}-day-${E}`
            ) })) })
          ]
        },
        `month-${N}`
      )) })
    }
  ) });
}, Ln = De((n) => ({
  section: {
    borderBottom: "0.5px solid rgba(0, 0, 0, 0.25)",
    paddingBottom: n.spacing(1),
    paddingLeft: n.spacing(2),
    paddingRight: n.spacing(1),
    paddingTop: n.spacing(2)
  }
})), Wn = ({
  config: { day: n, lastSearchUrl: e, month: t, multId: a, year: i },
  daysWithIssues: f,
  id: l,
  monthsWithIssues: d,
  neighbors: c,
  openMonth: m,
  requestDaysWithIssue: v,
  resetOpenMonth: _,
  undatedIssues: S,
  windowId: w
}) => {
  const { section: O } = Ln(), { t: j } = z();
  return /* @__PURE__ */ u.jsxs(
    gn,
    {
      id: l,
      title: j("calendarNavigation"),
      windowId: w,
      children: [
        /* @__PURE__ */ u.jsx(bn, { className: O, lastSearchUrl: e }),
        /* @__PURE__ */ u.jsx(An, { className: O, neighbors: c }),
        /* @__PURE__ */ u.jsx(
          jn,
          {
            className: O,
            day: n,
            month: t,
            multId: a,
            year: i
          }
        ),
        /* @__PURE__ */ u.jsx(
          kn,
          {
            className: O,
            daysWithIssues: f,
            monthsWithIssues: d,
            multId: a,
            openMonth: m,
            requestDaysWithIssue: v,
            resetOpenMonth: _,
            year: i
          }
        ),
        /* @__PURE__ */ u.jsx(Cn, { className: O, issues: S })
      ]
    }
  );
}, je = {
  de: {
    backToSearch: "Zurück zur Suche",
    calendar: "Kalender",
    calendarCurrentNewspaper: "Kalender der aktuellen Zeitung",
    calendarNavigation: "Kalendarnavigation",
    newspapersFromDate: "Zeitungen vom {{date}}",
    newspapersFromYear: "Zeitungen des Jahres {{year}}",
    nextIssue: "Nächste Ausgabe",
    noUndatedIssues: "Keine Ausgaben ohne Tagesdatum vorhanden.",
    openCompanionWindow_calendar: "Kalendarnavigation",
    previousIssue: "Vorherige Ausgabe",
    quickNavigation: "Schnellnavigation",
    undatedIssues: "Ohne Tagesdatum",
    yearOverview: "Jahresübersicht: {{year}}"
  },
  en: {
    backToSearch: "Back to search",
    calendar: "Calendar",
    calendarCurrentNewspaper: "Calendar of the current newspaper",
    calendarNavigation: "Calendar navigation",
    newspapersFromDate: "Newspapers from {{date}}",
    newspapersFromYear: "Newspapers of the year {{year}}",
    nextIssue: "Next issue",
    noUndatedIssues: "There are no issues without a specific date.",
    openCompanionWindow_calendar: "Calendar navigation",
    previousIssue: "Previous issue",
    quickNavigation: "Quick navigation",
    undatedIssues: "Without specific date",
    yearOverview: "Annual overview: {{year}}"
  }
};
var B = /* @__PURE__ */ ((n) => (n.RECEIVE_DAYS_WITH_ISSUES_FOR_MONTH = "mirador-calendarnavigation/RECEIVE_DAYS_WITH_ISSUES_FOR_MONTH", n.REQUEST_DAYS_WITH_ISSUES_FOR_MONTH = "mirador-calendarnavigation/REQUEST_DAYS_WITH_ISSUES_FOR_MONTH", n.RESET_OPEN_MONTH = "mirador-calendarnavigation/RESET_OPEN_MONTH", n.STORE_INITIAL_DATA = "mirador-calendarnavigation/STORE_INITIAL_DATA", n))(B || {});
const $n = (n, e) => ({
  payload: e,
  type: "mirador-calendarnavigation/RECEIVE_DAYS_WITH_ISSUES_FOR_MONTH",
  windowId: n
}), Un = (n, e) => ({
  payload: e,
  type: "mirador-calendarnavigation/REQUEST_DAYS_WITH_ISSUES_FOR_MONTH",
  windowId: n
}), Mn = (n) => ({
  type: "mirador-calendarnavigation/RESET_OPEN_MONTH",
  windowId: n
}), Yn = (n, e) => ({
  payload: e,
  type: "mirador-calendarnavigation/STORE_INITIAL_DATA",
  windowId: n
}), Fn = (n = {}, e) => {
  switch (e.type) {
    case B.RECEIVE_DAYS_WITH_ISSUES_FOR_MONTH:
      return {
        ...n,
        [e.windowId]: {
          ...n[e.windowId],
          daysWithIssues: {
            ...n[e.windowId].daysWithIssues,
            ...e.payload
          }
        }
      };
    case B.REQUEST_DAYS_WITH_ISSUES_FOR_MONTH:
      return {
        ...n,
        [e.windowId]: {
          ...n[e.windowId],
          openMonth: e.payload.month
        }
      };
    case B.RESET_OPEN_MONTH:
      return {
        ...n,
        [e.windowId]: {
          ...n[e.windowId],
          openMonth: void 0
        }
      };
    case B.STORE_INITIAL_DATA:
      return {
        ...n,
        [e.windowId]: {
          ...n[e.windowId],
          ...e.payload
        }
      };
    default:
      return n;
  }
};
var he = function(e) {
  return "@@redux-saga/" + e;
}, qn = /* @__PURE__ */ he("CANCEL_PROMISE"), Le = /* @__PURE__ */ he("IO"), Hn = /* @__PURE__ */ he("MULTICAST"), Vn = function(e) {
  return e == null;
}, b = function(e) {
  return e != null;
}, C = function(e) {
  return typeof e == "function";
}, Ee = function(e) {
  return typeof e == "string";
}, re = Array.isArray, Bn = function(e) {
  return e && !re(e) && typeof e == "object";
}, Ae = function n(e) {
  return e && (Ee(e) || zn(e) || C(e) || re(e) && e.every(n));
}, te = function(e) {
  return e && C(e.take) && C(e.close);
}, Kn = function(e) {
  return C(e) && e.hasOwnProperty("toString");
}, zn = function(e) {
  return !!e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype;
}, Gn = function(e) {
  return te(e) && e[Hn];
}, Jn = function(e) {
  return e && e[Le];
}, de = 2147483647;
function Qn(n, e) {
  if (e === void 0 && (e = !0), process.env.NODE_ENV !== "production" && n > de)
    throw new Error("delay only supports a maximum value of " + de + "ms");
  var t, a = new Promise(function(i) {
    t = setTimeout(i, Math.min(de, n), e);
  });
  return a[qn] = function() {
    clearTimeout(t);
  }, a;
}
process.env.NODE_ENV !== "production" && typeof Proxy < "u";
var Zn = function(e) {
  return e;
};
function R(n, e, t) {
  if (!e(n))
    throw new Error(t);
}
var Xn = function(e) {
  throw e;
}, er = function(e) {
  return {
    value: e,
    done: !0
  };
};
function nr(n, e, t) {
  e === void 0 && (e = Xn), t === void 0 && (t = "iterator");
  var a = {
    meta: {
      name: t
    },
    next: n,
    throw: e,
    return: er,
    isSagaIterator: !0
  };
  return typeof Symbol < "u" && (a[Symbol.iterator] = function() {
    return a;
  }), a;
}
var ve = "TAKE", rr = "PUT", tr = "ALL", ar = "CALL", ir = "FORK", or = "SELECT", M = function(e, t) {
  var a;
  return a = {}, a[Le] = !0, a.combinator = !1, a.type = e, a.payload = t, a;
};
function sr(n, e) {
  if (n === void 0 && (n = "*"), process.env.NODE_ENV !== "production" && arguments.length && R(arguments[0], b, "take(patternOrChannel): patternOrChannel is undefined"), Ae(n))
    return b(e) && console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types"), M(ve, {
      pattern: n
    });
  if (Gn(n) && b(e) && Ae(e))
    return M(ve, {
      channel: n,
      pattern: e
    });
  if (te(n))
    return b(e) && console.warn("take(channel) takes one argument but two were provided. Second argument is ignored."), M(ve, {
      channel: n
    });
  if (process.env.NODE_ENV !== "production")
    throw new Error("take(patternOrChannel): argument " + n + " is not valid channel or a valid pattern");
}
function We(n, e) {
  return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? (R(n, b, "put(channel, action): argument channel is undefined"), R(n, te, "put(channel, action): argument " + n + " is not a valid channel"), R(e, b, "put(channel, action): argument action is undefined")) : R(n, b, "put(action): argument action is undefined")), Vn(e) && (e = n, n = void 0), M(rr, {
    channel: n,
    action: e
  });
}
function ur(n) {
  var e = M(tr, n);
  return e.combinator = !0, e;
}
var $e = function(e, t) {
  if (R(t, b, e + ": argument fn is undefined or null"), !C(t)) {
    var a = null, i;
    if (re(t))
      a = t[0], i = t[1], R(i, b, e + ": argument of type [context, fn] has undefined or null `fn`");
    else if (Bn(t))
      a = t.context, i = t.fn, R(i, b, e + ": argument of type {context, fn} has undefined or null `fn`");
    else {
      R(t, C, e + ": argument fn is not function");
      return;
    }
    if (a && Ee(i)) {
      R(a[i], C, e + ': context arguments has no such method - "' + i + '"');
      return;
    }
    R(i, C, e + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
  }
};
function Ue(n, e) {
  var t = null, a;
  return C(n) ? a = n : (re(n) ? (t = n[0], a = n[1]) : (t = n.context, a = n.fn), t && Ee(a) && C(t[a]) && (a = t[a])), {
    context: t,
    fn: a,
    args: e
  };
}
var cr = function(e) {
  return e !== fr;
};
function J(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    t[a - 1] = arguments[a];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof t[0] == "number" ? t[0] : "ms";
    R(n, cr, "instead of writing `yield call(delay, " + i + ")` where delay is an effect from `redux-saga/effects` you should write `yield delay(" + i + ")`"), $e("call", n);
  }
  return M(ar, Ue(n, t));
}
function Me(n) {
  process.env.NODE_ENV !== "production" && ($e("fork", n), R(n, function(i) {
    return !Jn(i);
  }, "fork: argument must not be an effect"));
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    t[a - 1] = arguments[a];
  return M(ir, Ue(n, t));
}
function Ye(n) {
  n === void 0 && (n = Zn);
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    t[a - 1] = arguments[a];
  return process.env.NODE_ENV !== "production" && arguments.length && (R(arguments[0], b, "select(selector, [...]): argument selector is undefined"), R(n, C, "select(selector, [...]): argument " + n + " is not a function")), M(or, {
    selector: n,
    args: t
  });
}
var fr = /* @__PURE__ */ J.bind(null, Qn), Ce = function(e) {
  return {
    done: !0,
    value: e
  };
}, pe = {};
function lr(n) {
  return te(n) ? "channel" : Kn(n) ? String(n) : C(n) ? n.name : String(n);
}
function dr(n, e, t) {
  var a, i, f, l = e;
  function d(c, m) {
    if (l === pe)
      return Ce(c);
    if (m && !i)
      throw l = pe, m;
    a && a(c);
    var v = m ? n[i](m) : n[l]();
    return l = v.nextState, f = v.effect, a = v.stateUpdater, i = v.errorState, l === pe ? Ce(c) : f;
  }
  return nr(d, function(c) {
    return d(null, c);
  }, t);
}
function vr(n, e) {
  for (var t = arguments.length, a = new Array(t > 2 ? t - 2 : 0), i = 2; i < t; i++)
    a[i - 2] = arguments[i];
  var f = {
    done: !1,
    value: sr(n)
  }, l = function(v) {
    return {
      done: !1,
      value: Me.apply(void 0, [e].concat(a, [v]))
    };
  }, d, c = function(v) {
    return d = v;
  };
  return dr({
    q1: function() {
      return {
        nextState: "q2",
        effect: f,
        stateUpdater: c
      };
    },
    q2: function() {
      return {
        nextState: "q1",
        effect: l(d)
      };
    }
  }, "q1", "takeEvery(" + lr(n) + ", " + e.name + ")");
}
var pr = function(e, t, a) {
  R(t, b, e.name + " requires a pattern or channel"), R(a, b, e.name + " requires a saga parameter");
};
function me(n, e) {
  process.env.NODE_ENV !== "production" && pr(me, n, e);
  for (var t = arguments.length, a = new Array(t > 2 ? t - 2 : 0), i = 2; i < t; i++)
    a[i - 2] = arguments[i];
  return Me.apply(void 0, [vr, n, e].concat(a));
}
const gr = async ({
  month: n,
  multId: e,
  year: t
}) => {
  if (!n || !e || !t)
    return [];
  try {
    const a = `/api/calendar/${e}/${t}/${n}`, i = await fetch(a, {
      headers: {
        Accept: "application/json"
      },
      method: "GET"
    });
    if (!i.ok)
      return [];
    const { days: f } = await i.json();
    return f;
  } catch {
    return [];
  }
}, mr = async ({
  multId: n,
  year: e
}) => {
  if (!n || !e)
    return [];
  try {
    const t = `/api/calendar/${n}/${e}`, a = await fetch(t, {
      headers: {
        Accept: "application/json"
      },
      method: "GET"
    });
    if (!a.ok)
      return [];
    const { months: i } = await a.json();
    return i;
  } catch {
    return [];
  }
}, hr = async ({ issueId: n }) => {
  if (!n)
    return {};
  try {
    const e = `/api/neighbors/${n}`, t = await fetch(e, {
      headers: {
        Accept: "application/json"
      },
      method: "GET"
    });
    return t.ok ? await t.json() : {};
  } catch {
    return {};
  }
}, Er = async ({
  multId: n,
  year: e
}) => {
  if (!n || !e)
    return [];
  try {
    const t = `/api/viewer/${n}/${e}/undated`, a = await fetch(t, {
      headers: {
        Accept: "application/json"
      },
      method: "GET"
    });
    return a.ok ? await a.json() : [];
  } catch {
    return [];
  }
};
var X = "NOT_FOUND";
function yr(n) {
  var e;
  return {
    get: function(a) {
      return e && n(e.key, a) ? e.value : X;
    },
    put: function(a, i) {
      e = {
        key: a,
        value: i
      };
    },
    getEntries: function() {
      return e ? [e] : [];
    },
    clear: function() {
      e = void 0;
    }
  };
}
function _r(n, e) {
  var t = [];
  function a(d) {
    var c = t.findIndex(function(v) {
      return e(d, v.key);
    });
    if (c > -1) {
      var m = t[c];
      return c > 0 && (t.splice(c, 1), t.unshift(m)), m.value;
    }
    return X;
  }
  function i(d, c) {
    a(d) === X && (t.unshift({
      key: d,
      value: c
    }), t.length > n && t.pop());
  }
  function f() {
    return t;
  }
  function l() {
    t = [];
  }
  return {
    get: a,
    put: i,
    getEntries: f,
    clear: l
  };
}
var xr = function(e, t) {
  return e === t;
};
function Sr(n) {
  return function(t, a) {
    if (t === null || a === null || t.length !== a.length)
      return !1;
    for (var i = t.length, f = 0; f < i; f++)
      if (!n(t[f], a[f]))
        return !1;
    return !0;
  };
}
function Tr(n, e) {
  var t = typeof e == "object" ? e : {
    equalityCheck: e
  }, a = t.equalityCheck, i = a === void 0 ? xr : a, f = t.maxSize, l = f === void 0 ? 1 : f, d = t.resultEqualityCheck, c = Sr(i), m = l === 1 ? yr(c) : _r(l, c);
  function v() {
    var _ = m.get(arguments);
    if (_ === X) {
      if (_ = n.apply(null, arguments), d) {
        var S = m.getEntries(), w = S.find(function(O) {
          return d(O.value, _);
        });
        w && (_ = w.value);
      }
      m.put(arguments, _);
    }
    return _;
  }
  return v.clearCache = function() {
    return m.clear();
  }, v;
}
function Rr(n) {
  var e = Array.isArray(n[0]) ? n[0] : n;
  if (!e.every(function(a) {
    return typeof a == "function";
  })) {
    var t = e.map(function(a) {
      return typeof a == "function" ? "function " + (a.name || "unnamed") + "()" : typeof a;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + t + "]");
  }
  return e;
}
function wr(n) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    t[a - 1] = arguments[a];
  var i = function() {
    for (var l = arguments.length, d = new Array(l), c = 0; c < l; c++)
      d[c] = arguments[c];
    var m = 0, v, _ = {
      memoizeOptions: void 0
    }, S = d.pop();
    if (typeof S == "object" && (_ = S, S = d.pop()), typeof S != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof S + "]");
    var w = _, O = w.memoizeOptions, j = O === void 0 ? t : O, N = Array.isArray(j) ? j : [j], P = Rr(d), E = n.apply(void 0, [function() {
      return m++, S.apply(null, arguments);
    }].concat(N)), k = n(function() {
      for (var Q = [], Y = P.length, T = 0; T < Y; T++)
        Q.push(P[T].apply(null, arguments));
      return v = E.apply(null, Q), v;
    });
    return Object.assign(k, {
      resultFunc: S,
      memoizedResultFunc: E,
      dependencies: P,
      lastResult: function() {
        return v;
      },
      recomputations: function() {
        return m;
      },
      resetRecomputations: function() {
        return m = 0;
      }
    }), k;
  };
  return i;
}
var Or = /* @__PURE__ */ wr(Tr);
const Ir = (n, { key: e, windowId: t }) => {
  var a, i, f;
  return ((f = (i = (a = ne(n).calendar) == null ? void 0 : a[t]) == null ? void 0 : i.daysWithIssues) == null ? void 0 : f[e]) ?? [];
}, br = (n, { windowId: e }) => {
  var f;
  const { monthsWithIssues: t, neighbors: a, undatedIssues: i } = ((f = ne(n).calendar) == null ? void 0 : f[e]) ?? {};
  return {
    monthsWithIssues: t ?? [],
    neighbors: a ?? {},
    undatedIssues: i ?? []
  };
}, jr = (n, { windowId: e }) => {
  var a;
  const { openMonth: t } = ((a = ne(n).calendar) == null ? void 0 : a[e]) ?? {};
  return t;
}, Fe = Or(
  [wn],
  ({ calendarNavigation: n = {} }) => {
    if (!n.navDate)
      return n;
    const e = new Date(n.navDate);
    return {
      ...n,
      ...!isNaN(e.getTime()) && {
        day: e.getDate(),
        month: e.getMonth() + 1,
        year: e.getFullYear()
      }
    };
  }
), Ar = (n, { key: e, windowId: t }) => {
  var a;
  return Object.keys(
    ((a = ne(n).calendar) == null ? void 0 : a[t].daysWithIssues) ?? {}
  ).includes(e);
};
function* Cr({
  payload: { month: n, multId: e, year: t },
  windowId: a
}) {
  const i = `${e}-${t}-${n}`;
  if (!(yield Ye(Ar, {
    key: i,
    windowId: a
  }))) {
    const l = yield J(gr, {
      month: n,
      multId: e,
      year: t
    });
    yield We($n(a, { [i]: l }));
  }
}
function* Nr({
  window: { id: n }
}) {
  const { issueId: e, multId: t, year: a } = yield Ye(
    Fe,
    { windowId: n }
  ), [i, f, l] = yield ur([
    J(hr, { issueId: e }),
    J(mr, {
      multId: t,
      year: a
    }),
    J(Er, { multId: t, year: a })
  ]);
  yield We(
    Yn(n, { monthsWithIssues: f, neighbors: i, undatedIssues: l })
  );
}
function* Dr() {
  yield me(Rn.ADD_WINDOW, Nr), yield me(
    B.REQUEST_DAYS_WITH_ISSUES_FOR_MONTH,
    Cr
  );
}
const nt = [
  {
    component: ke,
    mode: "add",
    target: "WindowSideBarButtons",
    config: {
      translations: je
    }
  },
  {
    component: Wn,
    companionWindowKey: "calendar",
    mapDispatchToProps: (n, { windowId: e }) => ({
      requestDaysWithIssue: (t) => n(Un(e, t)),
      resetOpenMonth: () => n(Mn(e))
    }),
    mapStateToProps: (n, { windowId: e }) => {
      const t = Fe(n, { windowId: e }), { monthsWithIssues: a, neighbors: i, undatedIssues: f } = br(
        n,
        { windowId: e }
      ), l = jr(n, { windowId: e });
      return {
        config: t,
        daysWithIssues: Ir(n, {
          key: `${t.multId}-${t.year}-${l}`,
          windowId: e
        }),
        monthsWithIssues: a,
        neighbors: i,
        openMonth: l,
        undatedIssues: f
      };
    },
    reducers: {
      calendar: Fn
    },
    saga: Dr,
    config: {
      translations: je
    }
  }
];
export {
  nt as default
};
